import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AdminIconComponent } from './admin-icon.component';
import type { AdminMenuIconName } from './admin-icons';

@Component({
  selector: 'app-admin-sidebar-item',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, AdminIconComponent],
  template: `
    <a
      [routerLink]="route()"
      routerLinkActive="is-active"
      class="cg-admin-sidebar-item"
      [attr.aria-current]="null"
    >
      <span class="cg-admin-sidebar-item__icon" aria-hidden="true">
        <app-admin-icon [name]="icon()" />
      </span>
      <span class="cg-admin-sidebar-item__label">{{ label() }}</span>
    </a>
  `,
})
export class AdminSidebarItemComponent {
  readonly label = input.required<string>();
  readonly route = input.required<string>();
  readonly icon = input.required<AdminMenuIconName>();
}
